import { render, staticRenderFns } from "./footer-primary.vue?vue&type=template&id=714d1f22&scoped=true"
import script from "./footer-primary.vue?vue&type=script&lang=js"
export * from "./footer-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714d1f22",
  null
  
)

export default component.exports